import { useCallback, useContext } from 'react';
import ReportGadgetsContext from '../../../../../../contexts/ReportGadgetsContext';
import isV5ChartDef from '../../../../../../types/visTypeCheckers/isV5ChartDef';

/**
 * Returns a list of V5 chart definitions (Simple Grids) that use the given field
 * via simpleGridConfig.fields
 */
const useGetFieldSimpleGridUsage = () => {
  const { allGadgets } = useContext(ReportGadgetsContext);
  const definitions = allGadgets.map((g) => g.chartDef);

  const getFieldSimpleGridUsage = useCallback(
    (field: string, dataset: string) => {
      return definitions.filter((def) => {
        if (!isV5ChartDef(def)) return false;
        if (def.gadgetType !== 'simpleGrid') {
          return false;
        }
        const fields = def.simpleGridConfig?.fields || [];
        return (
          fields.includes(field) && def.simpleGridConfig?.dataType === dataset
        );
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allGadgets],
  );

  return getFieldSimpleGridUsage;
};

export default useGetFieldSimpleGridUsage;
